import CommonHeaderInner from "@/components/CommonHeaderInner/CommonHeaderInner";
import assest from "@/json/assest";
import Wrapper from "@/layout/wrapper/Wrapper";
import CustomButton from "@/ui/Buttons/CustomButton";
import styled from "@emotion/styled";
import {
  FormControl,
  InputLabel,
  MenuItem,
  NativeSelect,
  Select,
  SelectChangeEvent,
  Button,
  Typography,
  Grid,
  ListItem,
  List,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { Box, Container } from "@mui/system";
import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider, { InnerSlider } from 'react-slick';
import WhatPeopleSay from "@/components/WhatPeopleSay/WhatPeopleSay";
import Seo from "@/components/Seo/Seo";
import { Dialog, Paper, TextField, } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import Link from "next/link";

const HomeSec = styled(Box)`

.home-sec{
  padding-top: 70px;
}
  .home-top {
    display: flex;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px 8px 34px rgba(0, 0, 0, 0.08);
    padding: 30px 45px;
    border-radius: 157px;
    @media (max-width:1199px){
      padding: 15px 20px;
    }
    @media (max-width:899px){
      flex-wrap: wrap;
      border-radius: 20px;
      
    }
    .MuiFormLabel-root {
      font-weight: 500;
      font-size: 22px;
      text-transform: capitalize;
      display: flex;
      align-items: center;

      color: #1e294c;
      img {
        margin-right: 8px;
      }
    }
    .MuiNativeSelect-select {
      font-size: 16px;
      color: #99a2a4;
    }
    .MuiInputBase-root {
      border: 0 !important;

      &::before {
        display: none;
      }
      .MuiSvgIcon-root {
        color: #1e294c;
      }
    }
    .MuiFormControl-root {
      border-right: 0.707459px solid #bebdbd;
      margin-right: 17px;
      padding-right: 17px;
      width: 235px;
      @media (max-width:899px){
      border: 0;
      padding: 0;
      margin: 0 0 15px 0;

    }
    @media (max-width:899px){
      width: 100%;
    }
      &:last-child {
        border: 0;
        margin-right: 0;
      }
      &.form-last{
        border: 0;
        margin-right: 0;
        padding: 0;
      }
      .MuiSvgIcon-root {
        top:-10px;
        right: 40px;
        @media (max-width:1199px){
          right: 10px;
    }
      }
    }
    .MuiButtonBase-root{
      background: #1E294C;
      padding: 0;
      height: 60px;
      min-width: 60px;
      border-radius: 100%;
      &:hover{
        background: black;
      }

    }
  }

`;
const AboutSec = styled(Box)`
.about-sec{
  position: relative;
}
.skydot{
  position: absolute;
  left: 0;
  bottom:0;
  z-index:-1;
  @media (max-width:1500px) {
       width: 100px;
        
      }
      @media (max-width:1199px) {
       width: 60px;
        bottom: -50px;
      }
}
  .about-inr2 {
    padding-right: 40px;
    @media (max-width:899px) {
        padding:  25px 0 0 0 !important;
        /* margin-bottom: 30px; */
        
      }
    ul{
      padding: 45px 0;
      display: flex;
      flex-wrap: wrap;
      margin: -13px;
      @media (max-width:1199px) {
        padding: 25px 0;
        
      }
    }
    li{
      width: 33.33%;
      padding: 13px;
      @media (max-width:1199px) {
        padding: 8px;
        
      }
      @media (max-width:599px){
        width: 50%;
      }

      span{
        display: flex;
        align-items: center;
        img{
          margin-right: 5px;
        }
      }

      .MuiTypography-body1 {
        color: rgba(0, 0, 0, 0.5);
      }
    }
    .btn-outr {
      a {
        background: #1E294C;
        border-radius: 30px;
        color: #fff;
        min-width: 214px;
        padding: 16px 10px;
        border: 1px solid #1E294C;
        font-weight: 500;
        line-height: 1.5;
        font-size: 16px;
        text-transform: capitalize;
        font-family: 'Montserrat',sans-serif;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
          margin-right: 10px;
        }

        &:hover {
          background-color: #fff;
          color: #1E294C;
            img {
              filter: invert(90%) sepia(29%) saturate(2811%) hue-rotate(179deg) brightness(104%) contrast(97%);
            }
        }
      }
    }
    .cmn-head {
      cursor: pointer;
      display: inline-block;
    }
  }
  .about-fig {
    /* border-radius: 20px; */
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 610px;
    background: #eee;

    @media (max-width: 1199px) {
      height: auto;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 20px;
    }

    video {
      height: 100%;
      object-fit: cover;
    }
    /* @media (max-width:599px) {
      border-radius: 10px;
    } */
  }
  .about-row {
    align-items: center;
    &.topspaceone{
      margin: 105px 0;
    }
    
  }
  .leftspace{
      padding-left:80px !important;
    }
  .about-outr {
    position: relative;

    .cmn-head {
      @media (max-width: 599px) {
        margin-bottom: 10px;
      }
    }

    .MuiGrid-container {
      padding: 50px 0;

      @media (max-width: 899px) {
        flex-direction: column-reverse;
        padding: 25px 0;
      }

      &:first-child {
        padding-top: 0;
      }

      &:nth-child(even) {
        flex-flow: row-reverse;

        @media (max-width: 899px) {
          flex-flow: column-reverse;
        }
        .about-inr2 {
          padding: 0 0 0 80px;

          @media (max-width: 1199px) {
            padding-left: 30px;
          }

          @media (max-width: 899px) {
            padding-left: 0px;
          }
        }
      }
    }

    .blackdot {
      position: absolute;
      right: -100px;
      top: -20px;
      z-index: -1;
      @media (max-width:1400px) {
        right: -20px;
        top: -50px;
        width: 10%;
        margin-left: auto;
        
      }
      @media (max-width:899px){
        display: none;
      }
    }

    .slick-slider {

      .slick-arrow {
        z-index: 11;
        background-size: cover;
        display: none !important;

        &::before {
          display: none;
        }
      }

      .slick-prev {
        left: 15px;
        background-image: url(/assets/images/left-arrow-icon.png);
      }

      .slick-next {
        right: 15px;
        background-image: url(/assets/images/right-arrow-icon.png);
      }
    }
  }
  .about-sec {
    padding-bottom: 100px;
    &:nth-child(even) {
      .about-row {
        flex-direction: row-reverse;
        .about-inr {
          padding-right: 0;
          padding-left: 40px;
        }
      }
      .blackdot {
        right: auto;
        left: -100px;
      }
    }
    &:last-child {
      padding-bottom: 0px;
    }
  }
 .slider-nav{
    .about-fig{
      height: 90px;
      width: 94px;
      margin: auto;
      @media (max-width:1199px) {
      height: 60px;
      width: 60px;
      }
      @media (max-width:599px) {
      height: 50px;
      width: 50px;
      }
    }
  }
  .slidernav2{
    margin-top: -120px;
    @media (max-width:1199px) {
      margin-top: -85px;
      }

      figure {
        border-radius: 8px;
        box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 10%);
        img {
          border-radius: 8px;
        }
      }
      
  }
  .slidernav1{
    border-radius: 20px;
    overflow: hidden;
    line-height: 0;
  }
  .voidnav {
    display: none;
  }
`;
const EnqueryDialog = styled(Box)`
    text-align: center;

    .MuiTypography-body1 {
        max-width: 756px;
        margin: 0 auto 45px;
    }
    .MuiTextField-root {
        width: 100%;

        &:not(:last-child) {
        margin-bottom: 30px;
        }

        input {
        box-sizing: border-box;
        height: 70px;

        @media (max-width: 599px) {
            height: 50px;
        }
        }

        .MuiInputLabel-root {
        /* transform: translate(14px, 22px) scale(1); */
        color: #65676A;
        font-weight: 400;
        font-size: 16px;

        /* @media (max-width: 599px) {
            transform: translate(14px, 14px) scale(1);
        }

        &.Mui-focused {
            transform: translate(14px, -9px) scale(0.75);
        } */
        &.MuiInputLabel-shrink {
        padding-top: 0;
      }
        }

        .Mui-focused {
        .MuiOutlinedInput-notchedOutline {
            border-color: rgba(0, 0, 0, 0.23);
            border-width: 1px;
        }
        }
    }

    .MuiButtonBase-root {
        width: 100%;
        margin-top: 45px;
    }`
const ModalCloseBtn = styled(Button)`
    position: absolute;
    right: 15px;
    top: 15px;
    color: #1E294C;
    margin: 0 !important;
    width: auto !important;
    padding: 0;
    min-width: 1px;

    &:hover {
        background-color: #fff !important;
      }`
const homesloop = [
  {
    heading: "Home",
    comingsoon: true,
    dialog: true,
    content: "This luxurious home still has a few vacancies with private bathrooms located in Alexandria, Virginia. Call or email us now to schedule a tour!",
    type2: true,
    sliderData1: [
      {
        sliderImage: `${assest.aboutImg1}`,
        type: 'video'
      },
      {
        sliderImage: `${assest.aboutImg2}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.aboutImg3}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.aboutImg1}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.aboutImg2}`,
        type: 'img'
      }

    ],
    thumb: [
      {
        sliderImage: `${assest.aboutImg1}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.aboutImg2}`,
        type: 'video'
      },
      {
        sliderImage: `${assest.aboutImg3}`
      },
      {
        sliderImage: `${assest.aboutImg1}`
      },
      {
        sliderImage: `${assest.aboutImg2}`
      }

    ]
  },
  {
    heading: "Home",
    content: "We are still building the best homes that are first in class. If you are interested in something custom for your loved one or want to join a waiting list, please call or email us now!",
    type2: false,
    sliderData1: [
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      }

    ],
    thumb: [
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      }

    ]
  },
  {
    heading: "Home ",
    content: "We are still building the best homes that are first in class. If you are interested in something custom for your loved one or want to join a waiting list, please call or email us now!",
    type2: false,
    sliderData1: [
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      }

    ],
    thumb: [
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      },
      {
        sliderImage: `${assest.homeimg15}`,
        type: 'img'
      }

    ]
  }

]


const HomeSlider = ({ item, handleClickOpen, index }) => {

  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const [open2, setOpen2] = useState(false);

  const handleClickOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };

  return (
    <Grid container spacing={2} className="about-row">
      <Grid item xs={12} md={6}>
        <Box className="about-inr2">
          <Typography variant="h2" className="cmn-head" onClick={() => item?.dialog ? handleClickOpen2() : null}>{item.heading} <span>#{index + 1}</span></Typography>
          <Typography variant="body1">{item.content} </Typography>
          <Box className="btn-outr mt-5">
            {/* <CustomButton type="button" onClick={handleClickOpen} >
              <Typography variant="button">
                <Image
                  src={assest.btnimg}
                  alt="btn"
                  width={20}
                  height={20}
                />

                Enquiry Now
              </Typography>
            </CustomButton> */}
            {item.type2 ? (<Link href="mailto:info@aaaresidencies.com"><Image
              src={assest.btnimg}
              alt="btn"
              width={20}
              height={20}
            />

              Inquire</Link>) : (null)}

          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Slider asNavFor={nav1} ref={slider1} arrows={true} className="slidernav1"  >
          {item?.sliderData1?.map((data, index) => {
            return (
              <Box className="slider-nav-upr" key={index}>

                <figure className="about-fig">
                  {
                    data?.type === 'img' ? <Image
                      src={data.sliderImage}
                      alt="aboutimg1"
                      width={600}
                      height={500}
                    /> : <video width='100%' controls poster={assest.videoPoster}>
                      <source src="../assets/images/homevideo02.mp4" />
                    </video>
                  }
                </figure>
              </Box>
            )
          })}
        </Slider>
        {/* <Slider
          asNavFor={nav1}
          ref={slider2}
          slidesToShow={5}
          swipeToSlide={true}
          focusOnSelect={true}
          arrows={true}
          slidesToScroll={5}
          className={item?.comingsoon ? "slidernav2" : "voidnav"}
        >
          {item?.thumb.map((data, index) => {
            return (
              <Box className="slider-nav" key={index}>
                <figure className="about-fig">
                  <Image
                    src={data.sliderImage}
                    alt="aboutimg1"
                    width={94}
                    height={90}
                  />
                </figure>
              </Box>
            )
          })}
        </Slider> */}
      </Grid>
      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='md'
        fullWidth
        className="vdoModal"
      >
        <DialogActions>
          <Button onClick={handleClose2} autoFocus>
            <CancelIcon />
          </Button>
        </DialogActions>
        <DialogContent>
          <video autoPlay width='100%'>
            <source src="../assets/images/homevideo02.mp4" />
          </video>
        </DialogContent>
      </Dialog>
    </Grid>
  )
}


export default function Index() {

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Wrapper>
      <Seo title="Our Homes" canonical={""} description={""} url={""} image={""} />
      <CommonHeaderInner name={<Box>Our <span>Homes</span></Box>} pageName="Our Homes" />
      {/* <HomeSec>
        <Box className="home-sec">
          <Container fixed>
            <Box className="home-outr">
              <Box className="home-top">
                <FormControl fullWidth>
                  <InputLabel variant="standard" htmlFor="uncontrolled-native">
                    <Image
                      src={assest.locationIcon}
                      alt="selectIcon"
                      width={20}
                      height={22}
                    />{" "}
                    Location
                  </InputLabel>
                  <NativeSelect
                    disableUnderline
                    defaultValue={10}
                    inputProps={{
                      name: "age",
                      id: "uncontrolled-native",
                    }}
                  >
                    <option value={10}>Chicago</option>
                    <option value={20}>New York</option>
                    <option value={30}>Miami</option>
                  </NativeSelect>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel variant="standard" htmlFor="uncontrolled-native">
                    <Image
                      src={assest.locationIcon}
                      alt="selectIcon"
                      width={20}
                      height={22}
                    />
                    Provision
                  </InputLabel>
                  <NativeSelect
                    disableUnderline
                    defaultValue={10}
                    inputProps={{
                      name: "age",
                      id: "uncontrolled-native",
                    }}
                  >
                    <option value={10}>Name of Provision</option>
                    <option value={20}>demo</option>
                    <option value={30}>demo</option>
                  </NativeSelect>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel variant="standard" htmlFor="uncontrolled-native">
                    <Image
                      src={assest.locationIcon}
                      alt="selectIcon"
                      width={20}
                      height={22}
                    />
                    City
                  </InputLabel>
                  <NativeSelect
                    disableUnderline
                    defaultValue={10}
                    inputProps={{
                      name: "age",
                      id: "uncontrolled-native",
                    }}
                  >
                    <option value={10}>Name of City</option>
                    <option value={20}>demo</option>
                    <option value={30}>demo</option>
                  </NativeSelect>
                </FormControl>
                <FormControl fullWidth className="form-last">
                  <InputLabel variant="standard" htmlFor="uncontrolled-native">
                    <Image
                      src={assest.settings}
                      alt="selectIcon"
                      width={20}
                      height={22}
                    />
                    Services
                  </InputLabel>
                  <NativeSelect
                    disableUnderline
                    defaultValue={10}
                    inputProps={{
                      name: "age",
                      id: "uncontrolled-native",
                    }}
                  >
                    <option value={10}>Personal care</option>
                    <option value={20}>demo</option>
                    <option value={30}>demo</option>
                  </NativeSelect>
                </FormControl>
                <Button variant="text">
                  <Image
                    alt="srch-icon"
                    width={22}
                    height={22}
                    src={assest.searchIcon}
                  />
                </Button>
              </Box>
            </Box>
          </Container>
        </Box>
      </HomeSec> */}
      <AboutSec>
        <Box className="about-sec-main cmn_gap">
          <Box className="about-sec ">
            <Container fixed>
              <Box className="about-outr">
                {homesloop.map((item, index) => {
                  return (
                    <HomeSlider key={index} item={item} index={index} handleClickOpen={handleClickOpen} />
                  )
                }
                )}
                <span className="blackdot">
                  <Image
                    src={assest.bluedot}
                    alt="dot"
                    width={200}
                    height={200}
                  />
                </span>
              </Box>
            </Container>
            <span className="skydot">
              <Image
                src={assest.skydot}
                alt="dot"
                width={200}
                height={200}
              />
            </span>
          </Box>
        </Box>
      </AboutSec>
      <WhatPeopleSay />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='expDialog'
      >
        <EnqueryDialog>
          <ModalCloseBtn onClick={handleClose}>
            <CancelIcon />
          </ModalCloseBtn>
          <Typography variant="h2" className="cmn-head">
            Get <span>Started</span>
          </Typography>
          {/* <Typography variant="body1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis feugiat sem at dui tempor, ac tristique sapien posuere. Aliquam vel sagittis erat.
          </Typography> */}
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField id="outlined-basic" label="Name" />
                <TextField id="outlined-basic" label="Email" />
                <TextField id="outlined-basic" label="Phone" />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="outlined-multiline-static"
                  label="Message"
                  multiline
                  rows={10.3}
                />
              </Grid>
            </Grid>
          </Box>
          <CustomButton type="button"><Typography variant="button">Start</Typography></CustomButton>
        </EnqueryDialog>
      </Dialog>
    </Wrapper>
  );
}
